import { createChunksMatcher } from '../createChunksMatcher';
import { createChunk } from '../Chunks';
export function withHead(maybeResolvableHead, child) {
    return createChunksMatcher(maybeResolvableHead, child, function (head, request) { return head ? [createChunk('head', request, { head: head })] : []; });
}
//# sourceMappingURL=withHead.js.map